import { useState } from 'react';

import { useAuth } from '@features/auth/hooks/useAuth';
import {
  usePlayerClubsAndTournamentsQuery,
  usePlayerTournamentsQuery,
} from '@features/user/api/hooks';
import { PlayerClubsAndTournamentsFull } from '@features/user/ui/PlayerClubsAndTournaments/PlayerClubsAndTournamentsFull';

type Props = {
  onClose: () => void;
};
export function PlayerClubsAndTournamentsFullWidget({ onClose }: Props) {
  const { user } = useAuth();
  const [tab, setTab] = useState<'upcoming' | 'finished'>('upcoming');
  const { data } = usePlayerClubsAndTournamentsQuery();

  const {
    data: tournamentsData,
    hasNextPage,
    fetchNextPage,
  } = usePlayerTournamentsQuery({
    userId: user?.userId,
    upcoming: tab === 'upcoming',
    limit: 10,
  });

  const tournaments = tournamentsData?.myTournaments;
  const clubs = data?.myClubs;

  if (!clubs || !tournaments) return null;

  return (
    <PlayerClubsAndTournamentsFull
      clubs={clubs}
      tournaments={tournaments}
      totalTournamentsCount={tournamentsData.myTournamentsTotalCount}
      hasMoreTournaments={hasNextPage}
      loadMoreTournaments={fetchNextPage}
      onClose={onClose}
      tournamentTab={tab}
      onTabChange={setTab}
    />
  );
}
